import { initSubNav } from './subNav';

const NAV_OPEN_CLASS = 'nav-open';
const NAV_DROPDOWN_OPEN_CLASS = 'nav-dropdown-open';
const NAV_SEARCH_OPEN_CLASS = 'nav-search-open';
const NAV_STICKY_CLASS = 'nav-sticky';
const NAV_HOMEPAGE_SOLID_CLASS = 'nav-homepage-solid';
const NAV_HOMEPAGE_REVEAL_CLASS = 'nav-homepage-reveal';
const NAV_HOMEPAGE_HIDE_CLASS = 'nav-homepage-hide';
const DESKTOP_BREAKPOINT = 768;
const DROPDOWN_CLOSE_ANIMATION_MS = 300;
const NAV_REVEAL_ANIMATION_MS = 420;
const NAV_HIDE_ANIMATION_MS = 320;

function initNav() {
  const resetNavOpenState = () => {
    document.documentElement.classList.remove(NAV_OPEN_CLASS, NAV_SEARCH_OPEN_CLASS);
    document.body.classList.remove(NAV_OPEN_CLASS, NAV_SEARCH_OPEN_CLASS);
    document.body.style.top = '';
  };

  resetNavOpenState();

  const nav = document.querySelector('nav');
  const toggleButton = document.querySelector('.nav-toggle');
  const siteMenu = document.getElementById('site-menu');
  const backdropButton = document.querySelector('.site-menu__backdrop');
  const dropdown = document.querySelector('.nav-dropdown');
  const dropdownTriggers = Array.from(document.querySelectorAll('nav [data-dropdown-trigger]'));
  const dropdownPanels = Array.from(document.querySelectorAll('.nav-dropdown [data-dropdown-panel]'));
  const searchForm = document.querySelector('.nav-search-form');
  const searchInput = document.querySelector('.nav-search-input');
  const searchResetButton = document.querySelector('.nav-search-reset');
  const searchResultCount = document.querySelector('.nav-search-results-count');
  const searchItems = Array.from(document.querySelectorAll('.nav-search-results [data-search-item]'));
  const mobileSearchForm = document.querySelector('.site-menu__search-row');
  const mobileSearchInput = document.querySelector('.site-menu__search-input');
  const mobileSearchResultCount = document.querySelector('.site-menu__search-results-count');
  const mobileSearchItems = Array.from(document.querySelectorAll('.site-menu__search-results [data-search-item]'));
  const featuredPanel = document.getElementById('featured-panel');

  if (!nav || !toggleButton || !siteMenu || !backdropButton) {
    return;
  }

  let activePanelName = null;
  let closeAnimationTimer = null;
  let revealAnimationTimer = null;
  let hideAnimationTimer = null;
  let searchScrollY = 0;
  let isSearchScrollLocked = false;
  let menuScrollY = 0;
  let isMenuScrollLocked = false;
  let isHomepageNavSolid = false;

  const subNavController = initSubNav({
    nav,
    desktopBreakpoint: DESKTOP_BREAKPOINT,
  });

  const setMenuScrollLock = (isLocked) => {
    const hasOpenClass = document.body.classList.contains(NAV_OPEN_CLASS)
      || document.documentElement.classList.contains(NAV_OPEN_CLASS);

    if (isLocked === isMenuScrollLocked && isLocked === hasOpenClass) {
      return;
    }

    if (isLocked) {
      menuScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = `-${menuScrollY}px`;
      document.documentElement.classList.add(NAV_OPEN_CLASS);
      document.body.classList.add(NAV_OPEN_CLASS);
      isMenuScrollLocked = true;
      return;
    }

    const frozenTop = document.body.style.top || `-${menuScrollY}px`;
    document.documentElement.classList.remove(NAV_OPEN_CLASS);
    document.body.classList.remove(NAV_OPEN_CLASS);
    document.body.style.top = '';
    const restoredScrollY = menuScrollY || Math.abs(parseInt(frozenTop || '0', 10));
    menuScrollY = 0;
    isMenuScrollLocked = false;
    window.scrollTo(0, restoredScrollY);
  };

  const setSearchScrollLock = (isLocked) => {
    if (isLocked === isSearchScrollLocked) {
      return;
    }

    if (isLocked) {
      searchScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = `-${searchScrollY}px`;
      document.documentElement.classList.add(NAV_SEARCH_OPEN_CLASS);
      document.body.classList.add(NAV_SEARCH_OPEN_CLASS);
      isSearchScrollLocked = true;
      return;
    }

    const frozenTop = document.body.style.top || `-${searchScrollY}px`;
    document.documentElement.classList.remove(NAV_SEARCH_OPEN_CLASS);
    document.body.classList.remove(NAV_SEARCH_OPEN_CLASS);
    document.body.style.top = '';
    const restoredScrollY = searchScrollY || Math.abs(parseInt(frozenTop || '0', 10));
    searchScrollY = 0;
    isSearchScrollLocked = false;
    window.scrollTo(0, restoredScrollY);
  };

  const setHomepageSolidState = (isSolid) => {
    document.body.classList.toggle(NAV_HOMEPAGE_SOLID_CLASS, isSolid);
  };

  const setStickyState = (isSticky) => {
    document.body.classList.toggle(NAV_STICKY_CLASS, isSticky);
  };

  const updateHomepageNavState = () => {
    if (!document.body.classList.contains('is-homepage') || !featuredPanel) {
      nav.classList.remove(NAV_HOMEPAGE_REVEAL_CLASS);
      nav.classList.remove(NAV_HOMEPAGE_HIDE_CLASS);
      if (revealAnimationTimer) {
        window.clearTimeout(revealAnimationTimer);
        revealAnimationTimer = null;
      }
      if (hideAnimationTimer) {
        window.clearTimeout(hideAnimationTimer);
        hideAnimationTimer = null;
      }
      isHomepageNavSolid = false;
      setStickyState(false);
      setHomepageSolidState(false);
      return;
    }

    const featuredPanelBounds = featuredPanel.getBoundingClientRect();
    const featuredPanelMidpoint = featuredPanelBounds.top + (featuredPanelBounds.height / 2);
    const isPastFeaturedPanel = featuredPanelMidpoint <= 0;

    if (isPastFeaturedPanel) {
      nav.classList.remove(NAV_HOMEPAGE_HIDE_CLASS);
      if (hideAnimationTimer) {
        window.clearTimeout(hideAnimationTimer);
        hideAnimationTimer = null;
      }

      setStickyState(true);
      setHomepageSolidState(true);

      if (!isHomepageNavSolid) {
        nav.classList.remove(NAV_HOMEPAGE_REVEAL_CLASS);
        void nav.offsetWidth;
        nav.classList.add(NAV_HOMEPAGE_REVEAL_CLASS);

        if (revealAnimationTimer) {
          window.clearTimeout(revealAnimationTimer);
        }

        revealAnimationTimer = window.setTimeout(() => {
          nav.classList.remove(NAV_HOMEPAGE_REVEAL_CLASS);
          revealAnimationTimer = null;
        }, NAV_REVEAL_ANIMATION_MS);
      }

      isHomepageNavSolid = true;
      return;
    }

    nav.classList.remove(NAV_HOMEPAGE_REVEAL_CLASS);
    if (revealAnimationTimer) {
      window.clearTimeout(revealAnimationTimer);
      revealAnimationTimer = null;
    }

    if (isHomepageNavSolid) {
      nav.classList.remove(NAV_HOMEPAGE_HIDE_CLASS);
      void nav.offsetWidth;
      nav.classList.add(NAV_HOMEPAGE_HIDE_CLASS);

      if (hideAnimationTimer) {
        window.clearTimeout(hideAnimationTimer);
      }

      hideAnimationTimer = window.setTimeout(() => {
        nav.classList.remove(NAV_HOMEPAGE_HIDE_CLASS);
        setStickyState(false);
        setHomepageSolidState(false);
        hideAnimationTimer = null;
      }, NAV_HIDE_ANIMATION_MS);
    } else if (!hideAnimationTimer) {
      setStickyState(false);
      setHomepageSolidState(false);
    }

    isHomepageNavSolid = false;
  };

  updateHomepageNavState();

  const setState = (isOpen) => {
    toggleButton.classList.toggle('is-active', isOpen);
    toggleButton.setAttribute('aria-expanded', String(isOpen));
    siteMenu.classList.toggle('is-active', isOpen);
    backdropButton.classList.toggle('is-active', isOpen);
    siteMenu.setAttribute('aria-hidden', String(!isOpen));
    backdropButton.setAttribute('aria-hidden', String(!isOpen));
    setMenuScrollLock(isOpen);

    if (isOpen) {
      subNavController.closeTray();
    }

    updateHomepageNavState();
  };

  // Normalize to closed state on init in case stale classes/styles are present.
  setState(false);

  const setActiveDropdownPanel = (panelName) => {
    if (closeAnimationTimer) {
      window.clearTimeout(closeAnimationTimer);
      closeAnimationTimer = null;
    }

    if (!panelName && activePanelName) {
      const previousPanelName = activePanelName;

      dropdownTriggers.forEach((trigger) => {
        trigger.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
      });

      nav.classList.remove(NAV_DROPDOWN_OPEN_CLASS);
      dropdown?.setAttribute('aria-hidden', 'true');
      setSearchScrollLock(false);
      activePanelName = null;

      closeAnimationTimer = window.setTimeout(() => {
        dropdownPanels.forEach((panel) => {
          const isPreviousPanel = panel.getAttribute('data-dropdown-panel') === previousPanelName;
          if (isPreviousPanel) {
            panel.classList.remove('is-active');
          }
        });
        closeAnimationTimer = null;
      }, DROPDOWN_CLOSE_ANIMATION_MS);

      return;
    }

    activePanelName = panelName;

    dropdownTriggers.forEach((trigger) => {
      const isActive = trigger.getAttribute('data-dropdown-trigger') === panelName;
      trigger.classList.toggle('active', isActive);
      trigger.setAttribute('aria-expanded', String(isActive));
    });

    dropdownPanels.forEach((panel) => {
      const isActive = panel.getAttribute('data-dropdown-panel') === panelName;
      panel.classList.toggle('is-active', isActive);
    });

    nav.classList.toggle(NAV_DROPDOWN_OPEN_CLASS, Boolean(panelName));
    dropdown?.setAttribute('aria-hidden', String(!panelName));
    setSearchScrollLock(panelName === 'search');

    updateHomepageNavState();

    if (panelName === 'search' && searchInput) {
      window.requestAnimationFrame(() => {
        searchInput.focus();
      });
    }
  };

  const filterSearchItems = (query, items, countNode, showWhenQueryExists = true) => {
    if (!countNode || items.length === 0) {
      return;
    }

    let visibleCount = 0;

    items.forEach((item) => {
      const searchText = item.getAttribute('data-search-text') || '';
      const isMatch = query.length > 0 && searchText.includes(query);
      item.classList.toggle('is-visible', isMatch);
      item.hidden = !isMatch;

      if (isMatch) {
        visibleCount += 1;
      }
    });

    countNode.textContent = `Results: ${visibleCount}`;
    countNode.classList.toggle('is-visible', showWhenQueryExists ? query.length > 0 : true);
  };

  const updateSearchResults = () => {
    if (!searchInput || !searchResultCount || searchItems.length === 0) {
      return;
    }

    const query = searchInput.value.trim().toLowerCase();
    filterSearchItems(query, searchItems, searchResultCount, true);

    if (searchResetButton) {
      searchResetButton.classList.toggle('is-visible', query.length > 0);
    }
  };

  const runMobileSearch = () => {
    if (!mobileSearchInput || !mobileSearchResultCount || mobileSearchItems.length === 0) {
      return;
    }

    const query = mobileSearchInput.value.trim().toLowerCase();
    filterSearchItems(query, mobileSearchItems, mobileSearchResultCount, true);
  };

  if (searchForm) {
    searchForm.addEventListener('submit', (event) => {
      event.preventDefault();
    });

    searchForm.addEventListener('reset', () => {
      window.setTimeout(() => {
        updateSearchResults();
        if (searchInput) {
          searchInput.focus();
        }
      }, 0);
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', updateSearchResults);

    searchInput.addEventListener('search', updateSearchResults);

    updateSearchResults();
  }

  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('input', runMobileSearch);
    mobileSearchInput.addEventListener('search', runMobileSearch);

    runMobileSearch();
  }

  if (mobileSearchForm) {
    mobileSearchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      runMobileSearch();
    });
  }

  const toggleDropdownPanel = (panelName) => {
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      return;
    }

    if (activePanelName === panelName) {
      setActiveDropdownPanel(null);
      return;
    }

    setActiveDropdownPanel(panelName);
  };

  toggleButton.addEventListener('click', () => {
    const isOpen = !document.body.classList.contains(NAV_OPEN_CLASS);
    setState(isOpen);
  });

  backdropButton.addEventListener('click', () => {
    setState(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setState(false);
      setActiveDropdownPanel(null);
      subNavController.closeTray();
    }
  });

  siteMenu.addEventListener('click', (event) => {
    const target = event.target;
    if (target instanceof HTMLElement && target.closest('a')) {
      setState(false);
    }
  });

  dropdownTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const panelName = trigger.getAttribute('data-dropdown-trigger');
      if (!panelName) {
        return;
      }
      toggleDropdownPanel(panelName);
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Node)) {
      setActiveDropdownPanel(null);
      return;
    }

    const clickedInsideNav = nav.contains(target);
    const clickedInsideDropdown = dropdown ? dropdown.contains(target) : false;

    if (!clickedInsideNav && !clickedInsideDropdown) {
      setActiveDropdownPanel(null);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 996) {
      setState(false);
    }

    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      setActiveDropdownPanel(null);
      setSearchScrollLock(false);
    }

    subNavController.updateVisibility();
    updateHomepageNavState();
  });

  window.addEventListener('scroll', () => {
    subNavController.updateVisibility();
    updateHomepageNavState();
  }, { passive: true });

  window.addEventListener('pageshow', () => {
    resetNavOpenState();
    setState(false);
    setActiveDropdownPanel(null);
    subNavController.closeTray();
    subNavController.updateVisibility();
  });

}

document.addEventListener('DOMContentLoaded', initNav);
